if (!customElements.get('faq-filter')) {
  customElements.define(
    'faq-filter',
    class FaqFilter extends HTMLElement {
      constructor() {
        super();

        this.filterButtons = this.querySelectorAll('a.button');
        this.faqSections = document.querySelectorAll('.collapsible-content');

        this.filterButtons.forEach((filter) => {
          filter.addEventListener('click', (event) => {
            this.filter(event);
          });
        });
      }

      filter(event) {
        let id = event.target.hash.split('#');
        let activeSection = document.querySelector('section:has([id="' + id[1] + '"]) ~ section .collapsible-content');
        if (id[1] == 'all' || id[1] == '') {
          this.faqSections.forEach((section) => {
            section.classList.remove('inactive');
            section.classList.remove('active');
          });
          this.filterButtons.forEach((button) => {
            button.classList.remove('inactive');
            button.classList.remove('active');
          });
        } else {
          this.faqSections.forEach((section) => {
            section.classList.remove('active');
            section.classList.add('inactive');
          });
          this.filterButtons.forEach((button) => {
            button.classList.remove('active');
            button.classList.add('inactive');
          });
          activeSection.classList.remove('inactive');
          activeSection.classList.add('active');
        }
        event.target.classList.remove('inactive');
        event.target.classList.add('active');
      }
    }
  );
}
